// extracted by mini-css-extract-plugin
export default {"container":"NotesWidget_container__WJ+qq"};